"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var data_display_1 = require("../../data-display");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var variables_1 = require("../../../style/variables");
var CloseButton_1 = __importDefault(require("../../buttons/CloseButton"));
var ToastMedia = function (props) {
    if (props.type === 'image') {
        return (react_1.jsx("img", { css: { width: 80, margin: -16, marginRight: 0, objectFit: 'cover' }, src: props.imageSrc }));
    }
    if (props.type === 'icon') {
        return (react_1.jsx(data_display_1.FeaturedIcon, { css: { marginLeft: -4, marginTop: -4 }, theme: "light-circle-outline", size: "md", icon: props.icon, color: props.iconColor }));
    }
    if (props.type === 'avatar') {
        return (react_1.jsx(data_display_1.Avatar, __assign({}, props.avatarProps, { size: "md" })));
    }
    return null;
};
var ACTION_COLOR_MAP = {
    primary: style_1.DesignSystemThemeColor.Primary.DEFAULT,
    secondary: style_1.DesignSystemThemeColor.Gray.DEFAULT,
};
var Toast = function (props) { return (react_1.jsx(layout_1.Flex, { css: {
        width: 400,
        padding: 16,
        backgroundColor: '#fff',
        border: "1px solid " + style_1.DesignSystemThemeColor.Gray.LIGHT_4,
        boxShadow: "var(" + variables_1.Shadow.lg + ")",
        borderRadius: 8,
        overflow: 'hidden',
        pointerEvents: 'all',
    }, gap: props.type === 'image' ? 20 : 16 },
    react_1.jsx(ToastMedia, __assign({}, props)),
    react_1.jsx(layout_1.Flex, { direction: "column", gap: 16, css: { flex: 1, marginTop: 6 } },
        react_1.jsx(layout_1.Flex, { direction: "column", gap: 4 },
            react_1.jsx(Text_1.default.Body, { weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_4 }, props.title),
            props.subtitle ? (react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_2 }, props.subtitle)) : null),
        props.actions ? (react_1.jsx(layout_1.Flex, { gap: 12 }, props.actions.map(function (actionProps) { return (react_1.jsx("span", { key: actionProps.text, onClick: actionProps.onClick },
            react_1.jsx(Text_1.default.Body, { size: "sm", color: ACTION_COLOR_MAP[actionProps.type], css: { cursor: 'pointer' } }, actionProps.text))); }))) : null),
    react_1.jsx(CloseButton_1.default, { css: { marginTop: -8, marginRight: -8 }, onClick: props.onDismiss }))); };
exports.default = Toast;
